import { SVGProps } from 'react'

export function LoadingIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 0C50.41 0 52.3636 1.95367 52.3636 4.36364V21.8182C52.3636 24.2282 50.41 26.1818 48 26.1818C45.59 26.1818 43.6364 24.2282 43.6364 21.8182V4.36364C43.6364 1.95367 45.59 0 48 0ZM13.9322 13.9322C15.6363 12.2281 18.3992 12.2281 20.1033 13.9322L32.7579 26.5867C34.462 28.2908 34.462 31.0538 32.7579 32.7579C31.0538 34.462 28.2908 34.462 26.5867 32.7579L13.9322 20.1033C12.2281 18.3992 12.2281 15.6363 13.9322 13.9322ZM82.0672 13.9322C83.7713 15.6363 83.7713 18.3992 82.0672 20.1033L69.4126 32.7579C67.7085 34.462 64.9456 34.462 63.2415 32.7579C61.5374 31.0538 61.5374 28.2909 63.2415 26.5867L75.896 13.9322C77.6002 12.2281 80.3631 12.2281 82.0672 13.9322ZM0 48C0 45.59 1.95367 43.6364 4.36364 43.6364H21.8182C24.2282 43.6364 26.1818 45.59 26.1818 48C26.1818 50.41 24.2282 52.3636 21.8182 52.3636H4.36364C1.95367 52.3636 0 50.41 0 48ZM69.8182 48C69.8182 45.59 71.7718 43.6364 74.1818 43.6364H91.6364C94.0463 43.6364 96 45.59 96 48C96 50.41 94.0463 52.3636 91.6364 52.3636H74.1818C71.7718 52.3636 69.8182 50.41 69.8182 48ZM32.7579 63.2415C34.462 64.9456 34.462 67.7085 32.7579 69.4126L20.1033 82.0672C18.3992 83.7713 15.6363 83.7713 13.9322 82.0672C12.2281 80.3631 12.2281 77.6002 13.9322 75.896L26.5867 63.2415C28.2909 61.5374 31.0538 61.5374 32.7579 63.2415ZM63.2415 63.2415C64.9456 61.5374 67.7085 61.5374 69.4126 63.2415L82.0672 75.896C83.7713 77.6002 83.7713 80.3631 82.0672 82.0672C80.3631 83.7713 77.6002 83.7713 75.896 82.0672L63.2415 69.4126C61.5374 67.7085 61.5374 64.9456 63.2415 63.2415ZM48 69.8182C50.41 69.8182 52.3636 71.7718 52.3636 74.1818V91.6364C52.3636 94.0463 50.41 96 48 96C45.59 96 43.6364 94.0463 43.6364 91.6364V74.1818C43.6364 71.7718 45.59 69.8182 48 69.8182Z"
        fill="url(#paint0_radial_4599_27087)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4599_27087"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(74.0282 6.42254) rotate(100.911) scale(85.7186 212.38)"
        >
          <stop offset="0.162799" stopColor="#34CBFF" />
          <stop offset="0.269219" stopColor="#4DAFFC" />
          <stop offset="0.400926" stopColor="#B5A2E4" />
          <stop offset="0.484143" stopColor="#F398CA" />
          <stop offset="0.617953" stopColor="#F7BDC4" />
          <stop offset="0.714591" stopColor="#FDB697" />
          <stop offset="0.834295" stopColor="#FF986F" />
          <stop offset="1" stopColor="#FF7FB8" />
        </radialGradient>
      </defs>
    </svg>
  )
}
